import React from "react";
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import ActionButton from "./ActionButton";

const DeleteStaffWorkPatternModal = ({
  open,
  onClose,
  onConfirm,
  pattern,
  staffName,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Are you sure you want to delete the work pattern
        {pattern?.name ? ` "${pattern.name}"` : ""}
        {staffName ? ` for ${staffName}` : ""}?
      </DialogTitle>

      <DialogActions>
        <ActionButton onClick={onClose} tone="ghost">
          Cancel
        </ActionButton>

        <ActionButton onClick={onConfirm} tone="danger">
          Delete
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteStaffWorkPatternModal;